import { fps, setFPS, validFPS } from "@/state/config";
import type { FunctionalComponent } from "preact";
import Headline from "../Headline";

export interface Props {
    headline: string;
    class?: string;
}

const FPS: FunctionalComponent<Props> = (props) => {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    const onChange = (e: any) => {
        if (e.target?.value !== null) {
            setFPS(e.target.value);
        }
    };

    return (
        <div class={`w-48 ${props.class}`}>
            <Headline text={props.headline} />

            <select
                onChange={onChange}
                class="mt-1 block w-full rounded-md border-0 py-1 pr-10 pl-3 text-gray-900 text-xs ring-1 ring-gray-300 ring-inset focus:ring-2 focus:ring-[#00c3e3]"
            >
                {validFPS.map((res) => (
                    <option selected={fps.value === res} value={res} key={res}>
                        {res}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default FPS;
